<div class="nps">
  <ion-row>
    <ion-col class="point" *ngFor="let point of [].constructor(11);
    let i = index
  " (click)="rate=i;didRated.emit(i)">

      <div [class]="rate >= (i) ? ('active nps'+ i) : ''">
        {{ i }}
      </div>
    </ion-col>
  </ion-row>

</div>